// * This is custom code to remove comments and spaces from HTML content
import { Plugin } from "vite";

// * Function to remove comments and collapse whitespace in HTML content
function optimizeHtmlContent(html: string): string {
  // * Remove comments (but preserve scripts and styles)
  let optimizedHtml = html.replace(/<!--[\s\S]*?-->/g, "");

  // * Preserve script and style content
  const scriptStyleRegex =
    /(<script[^>]*>)([\s\S]*?)(<\/script>)|(<style[^>]*>)([\s\S]*?)(<\/style>)/gi;
  const preserved: string[] = [];
  let counter = 0;

  optimizedHtml = optimizedHtml.replace(scriptStyleRegex, (match) => {
    const placeholder = `___PRESERVED_${counter}___`;
    preserved[counter] = match;
    counter++;
    return placeholder;
  });

  // * Trim extra spaces (only outside of scripts/styles)
  optimizedHtml = optimizedHtml.replace(/\s{2,}/g, " ").trim();

  // * Restore preserved content
  preserved.forEach((content, index) => {
    optimizedHtml = optimizedHtml.replace(`___PRESERVED_${index}___`, content);
  });

  // * Remove redundant attributes
  optimizedHtml = optimizedHtml.replace(/\s*(\w+)=["']\1["']/g, "");

  // * Use short doctype
  optimizedHtml = optimizedHtml.replace(/<!DOCTYPE html>/i, "<!doctype html>");

  // * Remove empty attributes
  optimizedHtml = optimizedHtml.replace(/\s+\w+=""/g, "");

  // * Remove type attributes from style and link tags
  optimizedHtml = optimizedHtml.replace(
    /\s+type=["'](?:text\/css|text\/javascript)["']/g,
    "",
  );

  // * Keep closing slash for self-closing tags
  optimizedHtml = optimizedHtml.replace(
    /(<(img|br|hr|input|meta|link)[^>]*?)>/g,
    "$1 />",
  );

  return optimizedHtml;
}

function optimizeHtml(): Plugin {
  return {
    name: "optimize-html",
    apply: "build",
    enforce: "post",
    generateBundle(_, bundle) {
      const htmlFileName = "index.html";
      const htmlFile = bundle[htmlFileName];

      if (
        htmlFile &&
        htmlFile.type === "asset" &&
        typeof htmlFile.source === "string"
      ) {
        htmlFile.source = optimizeHtmlContent(htmlFile.source);
      }
    },
  };
}

export default optimizeHtml;
